var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "HqModal",
        {
          attrs: { visible: _vm.appointShow, title: "预约商机" },
          on: { "on-cancel": _vm.cancel }
        },
        [
          _c(
            "el-form",
            {
              ref: "form",
              attrs: { model: _vm.form, rules: _vm.appointRules }
            },
            [
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        [
                          _c("v-autocomplete", {
                            attrs: {
                              items: [
                                { name: "财经校区", id: 1 },
                                { name: "虚拟校区", id: 2 },
                                { name: "自考招生点", id: 3 },
                                { name: "学历外部团队", id: 4 }
                              ],
                              "menu-props": { bottom: true, offsetY: true },
                              label: "校区类型",
                              "item-text": "name",
                              "item-value": "id",
                              outlined: "",
                              dense: true,
                              height: 32,
                              clearable: true,
                              "clear-icon": "$clear",
                              "hide-details": "auto",
                              "no-data-text": "暂无数据"
                            },
                            on: { change: _vm.typeChange },
                            model: {
                              value: _vm.form.type,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "type", $$v)
                              },
                              expression: "form.type"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm.form.type === 1
                    ? _c(
                        "div",
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 24 } },
                            [
                              _c(
                                "el-form-item",
                                { attrs: { prop: "provinceCode" } },
                                [
                                  _c("v-autocomplete", {
                                    attrs: {
                                      items: _vm.provinceList,
                                      "menu-props": {
                                        bottom: true,
                                        offsetY: true
                                      },
                                      label: "省份",
                                      "item-text": "name",
                                      "item-value": "code",
                                      outlined: "",
                                      dense: true,
                                      height: 32,
                                      clearable: true,
                                      "clear-icon": "$clear",
                                      "hide-details": "auto",
                                      "no-data-text": "暂无数据"
                                    },
                                    on: { change: _vm.changeProvince },
                                    model: {
                                      value: _vm.form.provinceCode,
                                      callback: function($$v) {
                                        _vm.$set(_vm.form, "provinceCode", $$v)
                                      },
                                      expression: "form.provinceCode"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 24 } },
                            [
                              _c(
                                "el-form-item",
                                { attrs: { prop: "provinceCodecity" } },
                                [
                                  _c("v-autocomplete", {
                                    attrs: {
                                      items: _vm.cityList,
                                      "menu-props": {
                                        bottom: true,
                                        offsetY: true
                                      },
                                      label: "城市",
                                      "item-text": "name",
                                      "item-value": "code",
                                      outlined: "",
                                      dense: true,
                                      height: 32,
                                      clearable: true,
                                      "clear-icon": "$clear",
                                      "hide-details": "auto",
                                      "no-data-text": "暂无数据"
                                    },
                                    on: { change: _vm.changeCity },
                                    model: {
                                      value: _vm.form.provinceCodecity,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.form,
                                          "provinceCodecity",
                                          $$v
                                        )
                                      },
                                      expression: "form.provinceCodecity"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          staticStyle: { "margin-bottom": "8px" },
                          attrs: { prop: "schoolNcId" }
                        },
                        [
                          _c("v-autocomplete", {
                            attrs: {
                              items: _vm.schoolList,
                              "menu-props": { bottom: true, offsetY: true },
                              label: "校区",
                              "item-text": "deptName",
                              "item-value": "ncSchoolId",
                              outlined: "",
                              dense: true,
                              height: 32,
                              clearable: true,
                              disabled:
                                !_vm.form.provinceCode && _vm.form.type == 1,
                              "clear-icon": "$clear",
                              "hide-details": "auto",
                              "no-data-text": "暂无数据"
                            },
                            on: { change: _vm.changeSchool },
                            model: {
                              value: _vm.form.schoolNcId,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "schoolNcId", $$v)
                              },
                              expression: "form.schoolNcId"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { prop: "teacherUserId" } },
                        [
                          _c("v-autocomplete", {
                            attrs: {
                              items: _vm.teacherList,
                              "menu-props": { bottom: true, offsetY: true },
                              label: "招生老师",
                              "item-text": "username",
                              "item-value": "userId",
                              outlined: "",
                              dense: true,
                              height: 32,
                              clearable: true,
                              disabled: !_vm.form.schoolNcId,
                              "clear-icon": "$clear",
                              "hide-details": "auto",
                              "no-data-text": "暂无数据"
                            },
                            on: { change: _vm.changeTeacher },
                            model: {
                              value: _vm.form.teacherUserId,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "teacherUserId", $$v)
                              },
                              expression: "form.teacherUserId"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { prop: "appointmentTime" } },
                        [
                          _c(
                            "v-menu",
                            {
                              ref: "menu",
                              attrs: {
                                "close-on-content-click": false,
                                "return-value": _vm.year,
                                transition: "scale-transition",
                                "offset-y": "",
                                "min-width": "auto"
                              },
                              on: {
                                "update:returnValue": function($event) {
                                  _vm.year = $event
                                },
                                "update:return-value": function($event) {
                                  _vm.year = $event
                                }
                              },
                              scopedSlots: _vm._u([
                                {
                                  key: "activator",
                                  fn: function(ref) {
                                    var on = ref.on
                                    var attrs = ref.attrs
                                    return [
                                      _c(
                                        "v-text-field",
                                        _vm._g(
                                          _vm._b(
                                            {
                                              attrs: {
                                                label: "预约时间",
                                                "hide-details": "auto",
                                                outlined: "",
                                                dense: true,
                                                height: 32,
                                                clearable: true
                                              },
                                              model: {
                                                value: _vm.year,
                                                callback: function($$v) {
                                                  _vm.year = $$v
                                                },
                                                expression: "year"
                                              }
                                            },
                                            "v-text-field",
                                            attrs,
                                            false
                                          ),
                                          on
                                        )
                                      )
                                    ]
                                  }
                                }
                              ]),
                              model: {
                                value: _vm.menu,
                                callback: function($$v) {
                                  _vm.menu = $$v
                                },
                                expression: "menu"
                              }
                            },
                            [
                              _c(
                                "v-date-picker",
                                {
                                  attrs: { "no-title": "", locale: "zh-cn" },
                                  model: {
                                    value: _vm.year,
                                    callback: function($$v) {
                                      _vm.year = $$v
                                    },
                                    expression: "year"
                                  }
                                },
                                [
                                  _c("v-spacer"),
                                  _c(
                                    "v-btn",
                                    {
                                      attrs: { text: "", color: "primary" },
                                      on: {
                                        click: function($event) {
                                          _vm.menu = false
                                        }
                                      }
                                    },
                                    [_vm._v("取消")]
                                  ),
                                  _c(
                                    "v-btn",
                                    {
                                      attrs: { text: "", color: "primary" },
                                      on: {
                                        click: function($event) {
                                          return _vm.$refs.menu.save(_vm.year)
                                        }
                                      }
                                    },
                                    [_vm._v(" 确认 ")]
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 6 } },
                    [
                      _c("el-time-select", {
                        staticStyle: { width: "100%" },
                        attrs: {
                          size: "small",
                          "picker-options": {
                            start: "00:00",
                            step: "00:01",
                            end: "23:59"
                          },
                          placeholder: "选择时间"
                        },
                        model: {
                          value: _vm.hour,
                          callback: function($$v) {
                            _vm.hour = $$v
                          },
                          expression: "hour"
                        }
                      })
                    ],
                    1
                  ),
                  _vm.group
                    ? _c(
                        "el-col",
                        { attrs: { span: 24 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { prop: "phone" } },
                            [
                              _c("v-select", {
                                attrs: {
                                  items: _vm.phoneList,
                                  "menu-props": { bottom: true, offsetY: true },
                                  label: "成交号码",
                                  "item-text": "name",
                                  "item-value": "code",
                                  outlined: "",
                                  dense: true,
                                  height: 32,
                                  clearable: true,
                                  "clear-icon": "$clear",
                                  "hide-details": "auto",
                                  "no-data-text": "暂无数据"
                                },
                                model: {
                                  value: _vm.form.phone,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "phone", $$v)
                                  },
                                  expression: "form.phone"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              )
            ],
            1
          ),
          _c(
            "div",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c("el-button", { on: { click: _vm.cancel } }, [_vm._v("取消")]),
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: _vm.loading,
                      expression: "loading"
                    }
                  ],
                  attrs: { size: "small", type: "primary" },
                  on: {
                    click: function($event) {
                      return _vm.saveReserve("form")
                    }
                  }
                },
                [_vm._v("保存")]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }